<script setup lang="ts">
  import MainLayout from 'views/layouts/MainLayout.vue'
  import BannerAssineHorizontal from 'components/HomePage/BannerAssineHorizontal.vue'
  import ModalMessages from 'components/Modais/ModalMessages.vue'
  import ModalForgotPassword from 'components/Modais/ModalForgotPassword.vue'
  import LoginSocialMedia from 'components/LoginSocialMedia.vue'
</script>
<template>
  <MainLayout>
    <div class="slot-body">
      <div class="container">
        <div class="row pt-4 align-items-center">
          <div class="col-lg-3">
            <h1 class="title">{{ translate.title }}</h1>
          </div>
          <div class="col-lg-8 d-flex align-items-center">
            <span class="subtitle">{{ translate.subTitle }}</span>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-lg-6">
            <div class="col-lg-12">
              <form @submit.prevent="getLogin">
                <div class="form-group mt-3">
                  <input
                    type="text"
                    class="form-control"
                    id="inputEmail"
                    aria-describedby="emailHelp"
                    :placeholder="translate.placeHolderEmail"
                    name="email"
                    v-model="email"
                  />
                  <div class="input-group">
                    <input
                      v-if="hidden"
                      type="password"
                      class="form-control"
                      name="password"
                      id="inputPassword"
                      :placeholder="translate.placeHolderPassword"
                      autocomplete="current-password"
                      v-model="password"
                    />
                    <input
                      v-if="!hidden"
                      type="text"
                      class="form-control"
                      name="password"
                      id="inputPassword2"
                      :placeholder="translate.placeHolderPassword"
                      autocomplete="current-password"
                      v-model="password"
                    />
                    <i @click="hiddenPassword" class="input-group-text icon-eye"></i>
                  </div>
                </div>
                <div class="col-12 mb-4 mt-2">
                  <span class="small">{{ translate.forgotPwd1 }}</span>
                  <span class="small small-link" @click="showModalForgotPassword(true)">{{
                    translate.forgotPwd2
                  }}</span>
                </div>
                <div class="text-center mt-3" v-if="loading">
                  <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
                <div class="col-4 d-w-btn" v-else>
                  <button>{{ translate.buttonLabel }} <i class="icon-arrow-right"></i></button>
                </div>
              </form>
              <hr class="hr mt-4 hr-blurry" />
              <LoginSocialMedia redirect="homePage" size="245" @returnMessage="returnMessage"/>
              <span class="label-information"> {{ translate.labelInformation }}</span>
            </div>

            <ul class="bulleted-list u-mb-5 u-mb-md-0 mt-4">
              <li v-for="(list, index) in translate.listActivity" :key="index">
                <img :src="imgPath" alt="Icone BDS" />
                {{ list }}
              </li>
            </ul>
          </div>
          <div class="col-lg-6 d-flex justify-content-end d-sm-block d-none">
            <img class="img-default" :src="translate.imgDefault.src" :alt="translate.title" />
          </div>
        </div>
        <div class="row mt-3 pb-5 d-flex align-items-center justify-content-center">
          <BannerAssineHorizontal :path="bannerAssineHorizontal" />
        </div>
      </div>
    </div>
    <ModalForgotPassword
      :showModalPwd="showModalPwd"
      @showModalForgotPassword="showModalForgotPassword"
      @showModalMessages="showModalMessages"
    />
    <ModalMessages :options="optionsModal" @showModalMessages="showModalMessages" />
  </MainLayout>
</template>
<script lang="ts">
  import { defineComponent } from 'vue'
  import { mapState, mapActions } from 'pinia'
  import { userStore } from 'stores/user'
  import { jwtStore } from 'stores/jwt'
  import { localeStore } from 'stores/locale'
  import translaters from 'tradutors/myaccount'
  import IconeBds from 'assets/img/icone_BDS.png'
  import api from '../../api'
  import router from '../../router'
  import { event } from 'vue-gtag'
  import { isMobile } from "../shared/utils/mobile";

  export default defineComponent({
    name: 'LoginPage',
    components: {
      BannerAssineHorizontal
    },
    head() {
      return {
        templateParams: {
          subTitle: null,
          subPage: 'Login',
          page_url: window.location.origin + this.$route.fullPath,
          page_description:
            this.locale == 'pt-br'
              ? `Descubra o que de melhor o Bella da Semana tem a oferecer...`
              : `Discover the best that Bella Club has to offer ...`,
          page_image: '/favicon.ico',
          page_keywords:
            'bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site',
          page_locale: this.locale,
          page_url_pt: 'https://belladasemana.com.br/pt-br/login',
          page_url_en: 'https://belladasemana.com.br/en/login',
          page_canonical: 'https://belladasemana.com.br' + this.$route.fullPath
        }
      }
    },
    emits: ['showModalMessages'],
    computed: {
      ...mapState(localeStore, ['locale']),
      translate: function () {
        if (this.locale === 'pt-br') {
          return translaters.portugues
        } else {
          return translaters.ingles
        }
      }
    },
    created() {
      const lang = ['pt-br', 'en']
      if (lang.indexOf(this.$route.params.locale) === -1) {
        window.location.replace('/')
      }
      this.getBannerAssineHorizontal()
    },
    watch: {
      locale: function () {
        this.getBannerAssineHorizontal(true)
      }
    },
    data() {
      return {
        imgPath: IconeBds,
        hidden: true,
        password: '',
        email: '',
        bannerAssineHorizontal: '',
        loading: false,
        optionsModal: {
          showModal: false,
          titleModal: 'Erro',
          textBodyModal: '',
          textButtonModal: ''
        },
        showModalPwd: false,
        isMobile: isMobile(),
      }
    },
    methods: {
      ...mapActions(userStore, ['setUser', 'setIsActiveUser']),
      ...mapActions(jwtStore, ['setJwt']),
      hiddenPassword() {
        this.hidden = !this.hidden
      },
      async getActiveUser() {
        api.get('auth/isActiveUser').then(({ data }) => {
          this.setIsActiveUser(data.active)
        })
      },
      checkForm(form: object) {
        if (!form.email) {
          this.error(this.locale == 'pt-br' ? 'Email é obrigatório!' : 'Email is required!')
          return false
        }
        if (!form.password) {
          this.error(this.locale == 'pt-br' ? 'Senha é obrigatória!' : 'Password is required!')
          return false
        }

        return true
      },
      error(value) {
        this.showModalMessages({
          message: { show: true, title: 'Erro', textButton: 'Fechar', textBoby: value }
        })
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'erro',
          erro: {
            tipo: value
          }
        })
      },
      showModalMessages({ message }) {
        this.optionsModal.showModal = message.show
        this.optionsModal.titleModal = message.title
        this.optionsModal.textBodyModal = message.textBoby
        this.optionsModal.textButtonModal = message.textButton
      },
      async getLogin() {
        this.loading = true
        let body = {
          email: this.email,
          password: this.password
        }

        if (this.checkForm(body))
          await api
            .post('auth/login', body, {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
              }
            })
            .then(({ data }) => {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'login',
                login: { email: this.email }
              })
              event('login2', { login: { email: this.email } })
              this.setUser(data.user)
              this.setJwt(data.authorisation.token)
              this.getActiveUser()
              router.push({ name: 'homePage', params: { locale: this.locale } })
            })
            .catch(({ response: { data } }) => {
              if (data.errors) {
                let array = Array.from(Object.entries(data.errors), ([key, value]) => value)
                this.error(array[0][0])
              } else
                this.error(
                  this.locale == 'pt-br' ? 'Email ou Senha inválidos' : 'Email or Password invalid'
                )
            })
            .finally(() => (this.loading = false))
        else this.loading = false
      },
      async getBannerAssineHorizontal(changeLanguage = false) {
        if (!sessionStorage.getItem('bannerAssineHorizontal') || changeLanguage)
          api.get(`v1/home/getBannerSuper?mobile=${isMobile()}&language=${this.locale}`).then(({ data }) => {
            this.bannerAssineHorizontal = data.bannerAssineHorizontal
            sessionStorage.setItem(
              'bannerAssineHorizontal',
              JSON.stringify(this.bannerAssineHorizontal)
            )
          })
        else
          this.bannerAssineHorizontal = JSON.parse(sessionStorage.getItem('bannerAssineHorizontal'))
      },
      showModalForgotPassword(data) {
        this.showModalPwd = data
      },
      returnMessage(value) {
        this.error(value)
      }
    }
  })
</script>
<style scoped>
  .slot-body {
    margin-top: 65px !important;    
    background-color: #fff !important;
  }

  .title {
    color: #000000;
    font-family: 'Bebas-Neue-Light';
    font-size: 64px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 77px;
  }

  .subtitle {
    color: #5b5858;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
  }

  .img-default {
    width: 100%;
  }

  .d-w-btn button {
    color: #fff;
    padding: 5px;
  }

  .d-w-btn {
    width: 130px;
    background: #000;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    color: #ffffff;
    font-family: 'Exo-2';
    font-size: 16px;
    letter-spacing: 0;
  }

  .form-group input {
    padding: 15px 20px;
    border-radius: 30px;
    margin-bottom: 15px;
    background-color: #f8f8f8;
    font-size: small;
  }

  .input-group-text {
    padding: 0;
    padding-left: 5px;
    font-size: 2rem;
    background-color: #f8f8f8;
    border: 1px solid #ced4da;
    border-radius: 30px;
    border-left-style: hidden;
    height: 51px;
  }

  #inputPassword2 {
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
  }

  .icon-eye:before {
    color: #ced4da;
    margin-right: 0.5em;
    cursor: pointer;
  }

  hr {
    margin-top: 30px;
    border-bottom: solid 2px #ddd;
    margin-bottom: 30px;
  }

  .label-information {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
  }

  .bulleted-list li {
    color: #000000;
    font-family: 'Exo-2';
    font-size: 18px;
    letter-spacing: 0;
    line-height: 18px;
  }

  .bulleted-list img {
    width: 20px;
    margin-right: 0.75em;
    object-fit: cover;
  }

  .img-banner-rodape {
    width: 1020px;
    height: 127px;
  }

  .small {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 13px;
    letter-spacing: 0;
    line-height: 15px;
  }

  .small-link {
    color: #b20000;
    font-family: 'Roboto-Medium';
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 15px;
    text-decoration: underline;
    cursor: pointer;
  }

  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
    .img-banner-rodape {
      width: 100%;
    }

    .subtitle {
      color: #5b5858;
      font-family: 'Roboto-Regular';
      font-size: 16px;
      letter-spacing: 0;
      line-height: 19px;
    }

    .title {
      color: #000000;
      font-family: 'Bebas-Neue-Light';
      font-size: 48px;
      font-weight: 300;
      letter-spacing: 0;
      line-height: 58px;
    }

    .d-w-btn {
      left: 50%;
      transform: translate(-50%, 0%);
    }
  }
</style>
